import React from 'react'
import { FormattedMessage as T } from 'react-intl'

export const formatRangeLabel = (minValue, maxValue, min, max, type, units) => {
  if (minValue === 0 && maxValue === max) {
    return <T id='searchUtils.any' defaultMessage='Any {type}' values={{ type }} />
  }

  if (minValue === 0) {
    return <T id='searchUtils.lessThan' defaultMessage='Less than {maxValue} {units}' values={{ maxValue, units }} />
  }

  if (maxValue === max) {
    return <T id='searchUtils.moreThan' defaultMessage='More than {maxValue} {units}' values={{ maxValue, units }} />
  }

  return `${minValue} - ${maxValue} ${units}`
}
